import { type FunctionalComponent, h } from '@stencil/core';

interface ISmartSelector {
  accessibilityMode: boolean;
  title: string;
  language: string;
}

export const UIaaSSmartSelector: FunctionalComponent<ISmartSelector> = (props) => {
    const endpoint = `https://www.se.com/ww/${props.language}/download/download-api/getCountryLabels/`;

    return (
      <country-selector
        cs_endpoint={endpoint}
        country_code="ww"
        language_code={props.language}
        app_source="SE"
        locales={`ww_${props.language}`}
        cs_title={props.title}
        not_scoped_message="The specified document is not available anywhere.." //! for next phase, when items availability will be implemented
        toggle_click={props.accessibilityMode}
        enable_close='true'
        consumer_name="search"
      />
    );
};
